import { render } from "./SoporteCmms.vue?vue&type=template&id=34b06673"
import script from "./SoporteCmms.vue?vue&type=script&lang=js"
export * from "./SoporteCmms.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__